<template>
  <div class="collage-photo-item__image-container">
    <img v-lazy="media.image_url" class="collage-photo-item__image" :alt="media.id" v-if="!media.is_placeholder">
    <!--    <img v-lazy="'https://picsum.photos/800/600'" class="collage-photo-item__image" :alt="media.id" v-if="true">-->
    <div v-else class="skeleton-image"></div>
    <Icon v-if="media.media_type === 'video' && !media.is_placeholder" name="play" :width="20" class="play"/>
  </div>
</template>

<script>
export default {
  name: "ImageMedia",
  props: {
    media: {
      type: [Object, Number],
      required: true
    }
  }
}
</script>

<style scoped>

</style>